package com.anjuros.website.templates.template8.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template8.modules.Template8OpeningHours
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.util.ResKey
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8OpeningHoursSection(
) {
    Box(
        modifier = Modifier
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter
    ) {
        AnjurosImage(
            modifier = Modifier.fillMaxWidth()
                .height(400.px)
                .align(Alignment.Center)
                .objectFit(ObjectFit.Cover),
            src = Template8Res.Image.template8openinghours,
            alt = "Red Lion"
        )

        OpeningHours(
            modifier = Modifier
                .minWidth(350.px)
                .align(Alignment.Center)
        )

    }
}

@Composable
fun OpeningHours(modifier: Modifier){
    Column(
        modifier = modifier
            .padding(leftRight = 20.px, bottom = 20.px)
            .backgroundColor(Template8Theme.DarkGrey.rgb),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        P(
            attrs = Modifier
                .fontFamily(FONT_FAMILY)
                .fontSize(28.px)
                .fontWeight(FontWeight.Bold)
                .fontStyle(FontStyle.Italic)
                .color(Colors.White)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE8_OPENING_HOURS))

        }

        Template8OpeningHours.entries.forEach { day ->

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                P(
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY)
                        .margin(4.px)
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Colors.White)
                        .toAttrs()
                ) {
                    Text(LocalText( day.day))


                }
                P(
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY)
                        .margin(4.px)
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Colors.White)
                        .toAttrs()
                ) {

                    AnjurosText(day.openingTime, com.anjuros.website.components.language.ResKey.PLACEHOLDER_SERVICE_TIME)

                }
            }

        }
    }
}


